import React from 'react';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import Header from '../common/Header';
import Footer from '../common/Footer';

function PageWrapper({ children }) {
  return (
    <div className="m-0 w-full bg-secondary">
      <Header />

      <div className="w-full min-h-[calc(100vh-195px)]">
        {children || <Outlet />}
      </div>

      <Footer />
    </div>
  );
}

PageWrapper.propTypes = {
  children: PropTypes.node
};

PageWrapper.defaultProps = {
  children: null
};

export default PageWrapper;
